/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Channel_AllInputs */

const vi_order_channel_all = /** @type {(inputs: Order_Channel_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả kênh`)
};

/**

* @param {Order_Channel_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_channel_all = /** @type {((inputs?: Order_Channel_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Channel_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_channel_all(inputs)
});